import * as yup from 'yup';

import { StatusOperationBookingType, StatusBilling } from './Data.conf';

export const ActionConf = {
  schema: yup.object({
    status_operation_booking: yup.string().nullable(),
    status_billing: yup.string().nullable(),
  }),
  defaultValues: {
    status_operation_booking: null,
    status_billing: null,
  },
  fields: [
    {
      id: 'status_operation_booking',
      name: 'status_operation_booking',
      type: 'select-custom',
      label: 'Operational Status',
      options: StatusOperationBookingType,
      xs: 12,
      sm: 6,
      md: 4,
    },
    {
      id: 'status_billing',
      name: 'status_billing',
      type: 'select-custom',
      label: 'Billing Status',
      options: StatusBilling,
      xs: 12,
      sm: 6,
      md: 4,
    },
  ],
};
